module.exports = __webpack_public_path__ + "static/media/circles-bg.78c87ada.png";